import { animate, state, style, transition, trigger } from '@angular/animations';

export const dynamicAnimations = [
  trigger('openDynamicComponent', [
    state('scale', style({ transform: 'scale(1)' })),
    state('fromRight', style({ transform: 'translateX(0)' })),
    transition('scale => exit', [
      style({ transform: 'scale(1)' }),
      animate(200, style({ transform: 'scale(0)' })),
    ]),
    transition('void => scale', [
      style({ transform: 'scale(0)' }),
      animate(200, style({ transform: 'scale(1)' })),
    ]),
    transition('fromRight => exit', [
      style({ transform: 'translateX(0)' }),
      animate(300, style({ transform: 'translateX(100%)' })),
    ]),
    transition('void => fromRight', [
      style({ transform: 'translateX(100%)' }),
      animate(300, style({ transform: 'translateX(0)' })),
    ]),
  ]),
];

export const layoutAnimations = [
  trigger('rightBar', [
    state('rightBar', style({ transform: 'translateX(0)' })),
    transition(':enter', [
      style({ transform: 'translateX(-100%)' }),
      animate('0.5s 300ms ease-in'),
    ]),
    transition(':leave', [animate('0.3s ease-out', style({ transform: 'translateX(100%)' }))]),
  ]),
];

export const generalAnimations = [
  trigger('enterLeaveHeight', [
    transition(':enter', [
      style({ height: 0, opacity: 0 }),
      animate('.3s ease-out', style({ height: '*', opacity: 1 })),
    ]),
    transition(':leave', [
      style({ height: '*', opacity: 1 }),
      animate('.3s ease-in', style({ height: 0, opacity: 0 })),
    ]),
  ]),
  trigger('openCloseStateHeight', [
    state(
      'open',
      style({
        height: '*',
        opacity: 1,
      })
    ),
    state(
      'closed',
      style({
        height: '0px',
        opacity: 0.5,
      })
    ),
    transition('open => closed', [animate('.5s')]),
    transition('closed => open', [animate('.5s')]),
  ]),
];
